<template>
  <TheHeader
    :site-variant="siteVariant"
    :winnersPage="route.meta.winners"
  />
  <main>
    <router-view :site-variant="siteVariant" />
  </main>
  <TheFooter
    :site-variant="siteVariant"
    :winnersPage="route.meta.winners"
  />
</template>

<script setup>
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import { useRoute } from 'vue-router';
import {
  onBeforeMount, ref, watch,
} from 'vue';

const route = useRoute();

const siteVariant = ref('');

const setupSiteVariant = (name) => {
  if (name.includes('acura')) {
    siteVariant.value = 'acura';
  } else {
    siteVariant.value = 'honda';
  }
};

watch(route, (newRoute) => {
  setupSiteVariant(newRoute.name);
});

onBeforeMount(() => {
  setupSiteVariant(route.name);
});
</script>
